const baseData = {
  terminalmanage: {
    terminalInfo: {
      terminalNumber: "终端编号",
      terminalBarcode: "终端条形码",
      Version: "固件版本",
      SIMCardNumber: "SIM卡号",
      founder: "创建人",
      creationTime: "创建时间",
      seeHistory: "查看历史",
      wakeUpTimeInterval: "定时唤醒间隔(min)",
      unusualAlarmingValue: "三轴唤醒阈值",
      IOstate: "IO(1,2,3,4)",
      wakeUpTimeKeepDuration: "定时唤醒保持时间(min)",
      abnormalAlarmOff: "异动报警关闭",
      ChangeAlarm: "支持异动报警",
      turnOff: "关闭定时唤醒",
      trunOn: "启用定时唤醒",
      bindingState: "是否绑定",
      binding: "是",
      unbind: "否",
      authorize: "授权",
      searchWidth: {
        width1: "80px",
        width2: "70px",
        width3: "60px",
        width4: "50px"
      },
      tableWidth: "90",
      message: {
        noImportInfo: "无导入失败信息",
        selectSIM: "请选择需要导出的SIM卡"
      },
      createAndUpdate: {
        create: "新增OBD",
        update: "编辑OBD",
        error: {
          noSIM: "请选择sim卡",
          noTerminal: "请输入终端编号",
          terminalType: "只能输入开头不为0的8位数",
          noTerminalBarcode: "请输入OBD设备号",
          terminalBarcodeType: "V2A开头加5到7位字母或数字，共8~10位",
          noOBDcode: "请输入OBD设备号",
          OBDcodeType: "只能输以A027E00428的30位字符",
          noExpritTime: "请选择过期时间"
        },
        labelWidth: "85px"
      }
    },
    SIM: {
      SIMCardNumber: "SIM卡号",
      CarrierType: "运营商类型",
      searchWidth: {
        width1: "60px",
        width2: "60px"
      },
      message: "无导入失败sim卡信息",
      operator: "运营商",
      createAndUpdate: {
        create: "新增SIM卡",
        update: "编辑SIM卡",
        message: {
          noSim: "请输入sim卡号",
          simTypeError: "移动sim卡号为11位数字",
          unicomError: "联通sim卡号20位字母和数字",
          selectOperator: "请选择运营商",
          noIccid: "请输入ICCID",
          iccidTypeError: "ICCID为20位字母和数字"
        },
        labelWidth: "70px"
      }
    },
    terminalchange: {
      terminalNumber: "终端编号",
      searchWidth: {
        width1: "60px",
        width2: "60px",
        width3: "45px",
        width4: "75px"
      },
      binding: "已绑定",
      unbind: "已解绑",
      SIMCardNumber: "SIM卡号",
      bindingState: "绑定状态",
      founder: "创建人",
      unbundlingPeople: "解绑人",
      reason: "更换原因",
      tableWidth: {
        terminalNumber: "100",
        bindingState: "100",
        unbundlingPeople: "90"
      },
      msg1: "请选择OBD设备号",
      msg2: "请输入更换原因"
    }
  },
  configResponse:{
    configName:"配置文件",
    responseType:"配置类型",
    responseInit:"是否清空本地保存数据",
    responsePacketCount:"车辆运行数据打包数量",
    responseDistance:"车辆运行数据采集距离间隔",
    responseHeadErrCode:"标识出错原因",
    responseFlameoutVoltage:"熄火后关机电压设定(0.1V)",
    responseVersion:"软件版本号",
    responseFlameoutWait:"熄火后等待时间",
    responseDataMode:"数据采集模式",
    responseUpgradeAddress:"软件升级地址",
    responseHeadErrMsg:"出错原因描述",
    responseBusinessAddress:"业务服务器地址",
    responseLinkHeartbeat:"链路检测心跳间隔(秒)",
    responseSleepReportInterval:"休眠后定期汇报间隔(分)",
    responseHeadCmd:"回应指令",
    responseInterval:"车辆运行数据采集时间间隔(秒)",
    responseSleepVoltageInterval:"休眠后电压汇报间隔(0.1V)",
    responseFlameoutShutdown:"熄火后关机时间设定(分)",
    responseAgpsAddress:"AGPS 服务地址",
    createAndUpdate:{
      create: "新增OBD配置响应",
      update: "编辑OBD配置响应",
      error: {
        noConfigName:"请输入配置文件名",
        noEmpty:"不能有空",
        isNumber:"应该为数字"
      },
      labelWidth: "85px"
    }
  },
  terminalConfig:{    
    terminalId: "终端id",
    responseVid:"车辆类型",
    responseYear:"年款",
    responseDisplacement:"排量",
    responseInit:"是否清空本地保存数据",
    configName:"配置文件",
    terminalCode:"终端码",
    createAndUpdate:{
      binding:"选择终端绑定配置",
      create: "新增95OBD设备配置",
      update: "编辑95OBD设备配置"
    }
  }
} 
export default baseData